'use strict';

var productItem = require('../helpers/productItem');

/**
 * Measure product dettails viewed using an 'view_item' actionFieldObject
 * and a list of productFieldObjects.
 *
 * @param {Object} productData An object representing a product.
 * @param {array} dataLayer
 */
function piwikTriggerProductDetailViewEvent(productData, dataLayer) {
    try {
        var data = {
            event: 'view_item',
            ecommerce: {
                currency: productData.currencyCode,
                value: Number(parseFloat(productData.products[0].price).toFixed(2)),
                items: productData.products.map(function (product) {
                    return productItem.productFormatted(product);
                })
            }
        };

        dataLayer.push({ ecommerce: null });
        dataLayer.push(data);
    } catch (e) {
        console.error('Piwik Analytics: Error in piwikTriggerProductDetailViewEvent:', e);
    }
}

$(function () {
    piwikTriggerProductDetailViewEvent(window.piwikProductData || {}, window.dataLayer || []);
});
